import { useEffect, useState, useCallback } from 'react';
import dayjs from 'dayjs';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import {
  AddLinkRounded,
  CheckCircleOutlineRounded,
  CloseRounded,
  ContentCopyRounded,
} from '@mui/icons-material';
import { toast } from 'react-toastify';

import {
  Container,
  Section,
  Input,
  HeaderCreate,
  Title,
  VideoconferenceTitle,
  LinkAdress,
  SuccessRemovedZoom,
  TextRemovedZoom,
  ButtonExternal,
  ButtonZoom,
  SuccessOAuth,
  TextZoom,
} from './styles';

import Jitsi from '../../../../assets/JitsiLogo.png';

import {
  getMeetingByIdRequest,
  Guest,
  Meeting,
} from '../../../../services/requests';

import { getCurrentTimezone } from '../../../../utils/dateHelpers';

import useCompanyStore from '../../../../store/companies';
import useAuthStore from '../../../../store/auth';
import { ConfirmModal } from '../../../../components/ConfirmModal';

interface EditarReuniaoProps {
  handleMeeting: (formData: any) => void;
  setOpenDrawerEditMeeting: (type: boolean) => void;
  handleRemoveMeeting: () => void;
  setDialogCancelOpen: (type: boolean) => void;
  dialogCancelOpen: boolean;
  linkZoomRemoved: boolean;
  setLinkZoomRemoved: (type: boolean) => void;
  authorizationCode: string | null;
  setAuthorizationCode: (type: string | null) => void;
  zoomActived: boolean;
  setZoomActived: (type: any) => void;
  setLoadingZoom: (type: boolean) => void;
  hasJitsi: boolean;
  setHasJitsi: (type: boolean) => void;
  jitsiActived: any;
  setJitsiActived: (type: any) => void;
  linkJitsiRemoved: boolean;
  setLinkJitsiRemoved: (type: any) => void;
}

dayjs().format();

export interface GuestToSelect extends Guest {
  selected: boolean;
}

export function EditarReuniao({
  handleMeeting,
  setOpenDrawerEditMeeting,
  handleRemoveMeeting,
  setDialogCancelOpen,
  dialogCancelOpen,
  linkZoomRemoved,
  setLinkZoomRemoved,
  authorizationCode,
  setAuthorizationCode,
  zoomActived,
  setZoomActived,
  setLoadingZoom,
  hasJitsi,
  setHasJitsi,
  jitsiActived,
  setJitsiActived,
  linkJitsiRemoved,
  setLinkJitsiRemoved,
}: EditarReuniaoProps) {
  const params = useParams();
  const selectedCompany = useCompanyStore(state => state.selectedCompany);
  const user = useAuthStore(state => state.user);

  const [meetingType, setMeetingType] = useState('LT3');
  const [showOnlineInputZoom, setShowOnlineInputZoom] = useState(false);
  const [showOnlineInputOthers, setShowOnlineInputOthers] = useState(false);
  const [showOnlineInputTeams, setShowOnlineInputTeams] = useState(false);
  const [dataInicial, setDataInicial] = useState('');
  const [duration, setDuration] = useState(0);
  const [linkAdress, setLinkAdress] = useState('');
  const [tokenZoom, setTokenZoom] = useState<string | null>(null);
  const [openModalToRemoveZoom, setOpenModalToRemoveZoom] =
    useState<boolean>(false);
  const [externalActived, setExternalActived] = useState(true);
  const [openModalToAuthZoom, setOpenModalToAuthZoom] = useState(false);
  const [openModalToDisconnectZoom, setOpenModalToDisconnectZoom] =
    useState(false);
  const [openModalToRemoveJitsi, setOpenModalToRemoveJitsi] = useState(false);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      title: Yup.string().required('O título é obrigatório.'),
      start_at: Yup.string().required('A data inicial é obrigatória.'),
      duration: Yup.number()
        .min(1, 'A duração não pode ser menor que 1')
        .moreThan(0, 'A duração deve ser maior que 0')
        .required('A duração é obrigatória.'),
      meeting_type: Yup.string().nullable(),
      link_address: Yup.string()
        .nullable()
        .url('Digite um link de reunião válido'),
      local_address: Yup.string().nullable(),
    });
  }, []);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { isSubmitting, isDirty },
  } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const getMeetingById = useCallback(async () => {
    const meetingId = params?.id;

    if (meetingId) {
      const response: Meeting = await getMeetingByIdRequest(
        meetingId as string,
        user?.id as string,
      );

      setValue('title', response.title);
      setValue(
        'start_at',
        dayjs(response.start_at)
          .tz(getCurrentTimezone(), true)
          .format('YYYY-MM-DDTHH:mm'),
      );
      setDataInicial(
        dayjs(response.start_at)
          .tz(getCurrentTimezone(), true)
          .format('YYYY-MM-DDTHH:mm'),
      );
      setValue('duration', response.duration);
      setDuration(response.duration);
      setValue('link_address', response.link_address);
      setValue('local_address', response.local_address);
      setLinkAdress(response.link_address as string);
      setTokenZoom(response?.refresh_token_zoom);
      setHasJitsi(
        (response?.link_address?.includes('jit.si') &&
          response?.link_address?.includes(params?.id as string)) ||
          false,
      );
    }
  }, [params?.id, setHasJitsi, setValue, user?.id]);

  useEffect(() => {
    if (selectedCompany && params?.id) {
      if (params?.id) {
        getMeetingById();
      }
    }
  }, [selectedCompany, params]);

  useEffect(() => {
    if (hasJitsi) {
      setMeetingType('LT4');
    } else if (linkAdress === null || linkAdress?.length === 0) {
      setMeetingType('LT3');
    }
  }, [hasJitsi, linkAdress]);

  const contentCopy = () => {
    navigator.clipboard
      .writeText(linkAdress)
      .then(() => {
        toast.success('Texto copiado para a área de transferência!', {
          toastId: 1,
        });
      })
      .catch(error => {
        console.error('Erro ao copiar o texto:', error);
      });
  };

  const handleRemoveZoom = useCallback(() => {
    setLinkZoomRemoved(true);
    setOpenModalToRemoveZoom(false);
  }, [setLinkZoomRemoved]);

  const handleRemoveJitsi = useCallback(() => {
    setLinkJitsiRemoved(true);
    setOpenModalToRemoveJitsi(false);
  }, [setLinkJitsiRemoved]);

  const handleSelectConference = useCallback(
    (conference: string) => {
      if (conference === 'external') {
        setExternalActived(prevState => !prevState);
        if (!externalActived) {
          setMeetingType('LT3');
        } else {
          setMeetingType('');
        }
        setZoomActived(false);
        // setTeamsActived(false);
        setJitsiActived(false);
      }
      if (conference === 'zoom') {
        setZoomActived((prevState: any) => !prevState);
        setMeetingType('');
        // setTeamsActived(false);
        setOpenModalToAuthZoom(false);
        setExternalActived(false);
        setJitsiActived(false);
      }
      if (conference === 'teams') {
        // setTeamsActived((prevState: any) => !prevState);
        setMeetingType('');
        setZoomActived(false);
        setExternalActived(false);
        setJitsiActived(false);
      }
      if (conference === 'jitsi') {
        setJitsiActived((prevState: any) => !prevState);
        setMeetingType('');
        // setTeamsActived(false);
        setZoomActived(false);
        setExternalActived(false);
      }
    },
    [externalActived, setJitsiActived, setZoomActived],
  );

  useEffect(() => {
    if (meetingType === 'LT1') {
      setShowOnlineInputZoom(true);
      setShowOnlineInputTeams(false);
      setShowOnlineInputOthers(false);
    } else if (meetingType === 'LT2') {
      setShowOnlineInputTeams(true);
      setShowOnlineInputZoom(false);
      setShowOnlineInputOthers(false);
    } else if (meetingType === 'LT3') {
      setShowOnlineInputTeams(false);
      setShowOnlineInputZoom(false);
      setShowOnlineInputOthers(true);
    } else if (meetingType === 'LT4') {
      setShowOnlineInputTeams(false);
      setShowOnlineInputZoom(false);
      setShowOnlineInputOthers(false);
      setJitsiActived(false);
    } else {
      setShowOnlineInputTeams(false);
      setShowOnlineInputZoom(false);
      setShowOnlineInputOthers(false);
    }
  }, [meetingType, setJitsiActived]);

  const handleDisconnectZoom = useCallback(() => {
    setAuthorizationCode('');
    setOpenModalToDisconnectZoom(false);
    handleSelectConference('external');
  }, [handleSelectConference, setAuthorizationCode]);

  useEffect(() => {
    if (zoomActived) {
      setLoadingZoom(true);
      window.open(
        `https://zoom.us/oauth/authorize?response_type=code&client_id=YL1SUUvMRtqQEdOMG6CCw&redirect_uri=${process.env.REACT_APP_API_URL}/autenticacao-sucesso`,
      );
    }
  }, [zoomActived]);

  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.data.authorizationCode) {
          setLoadingZoom(false);

          toast.success('Autenticado com sucesso', { toastId: 1 });
          setAuthorizationCode(event.data.authorizationCode);
        }
      },
      false,
    );
  }, [setAuthorizationCode, setLoadingZoom]);

  return (
    <Container>
      <HeaderCreate>
        <IconButton
          onClick={() => setOpenDrawerEditMeeting(false)}
          disabled={isSubmitting}
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
        >
          <CloseRounded />
        </IconButton>
        <Title>Editar reunião</Title>
      </HeaderCreate>
      <Typography className="title">
        Configure a data, título, local e duração da reunião
      </Typography>
      <Section>
        <form onSubmit={handleSubmit(handleMeeting)} className="content">
          <Box display="flex" flexDirection="column" width="100%">
            <Input
              name="title"
              label="Título da Reunião"
              control={control}
              disabled={isSubmitting}
              required
              className="inputs"
              type="text"
              placeholder="Título da Reunião"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <div className="input-date">
              <div className="date">
                <TextField
                  label="Data de inicio"
                  // className="initial-input"
                  type="datetime-local"
                  value={dataInicial}
                  disabled={isSubmitting}
                  onChange={t => {
                    setDataInicial(t.target.value);
                    setValue('start_at', t.target.value);
                  }}
                  name="start_at"
                  // control={control}
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className="date">
                <TextField
                  // className="initial-input"
                  value={duration}
                  onChange={t => {
                    setDuration(t.target.value as any);
                    setValue('duration', Number(t.target.value));
                  }}
                  name="duration"
                  disabled={isSubmitting}
                  label="Duração em minutos"
                  inputProps={{ min: 1 }}
                  fullWidth
                  type="number"
                  placeholder="Duração"
                  // control={control}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            <Input
              className="inputs"
              type="text"
              label="Local da reunião"
              disabled={isSubmitting}
              placeholder="Ex: Avenida..."
              name="local_address"
              control={control}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <VideoconferenceTitle>Vídeoconferência:</VideoconferenceTitle>
            <Box
              display="flex"
              alignItems={hasJitsi ? 'center' : 'flex-start'}
              gap="10px"
              marginTop="5px"
            >
              <LinkAdress>
                {hasJitsi ? (
                  <a href={linkAdress} target="_blank" rel="noreferrer">
                    {linkAdress}
                  </a>
                ) : (
                  <>
                    {!authorizationCode && (
                      <ButtonExternal
                        disabled={isSubmitting}
                        isActived={externalActived}
                        onClick={() => handleSelectConference('external')}
                      >
                        <AddLinkRounded
                          color="info"
                          sx={{ width: '29px', height: '29px' }}
                        />
                        Link externo
                      </ButtonExternal>
                    )}
                    {/* <ButtonZoom
                      isActived={zoomActived}
                      onClick={
                        authorizationCode
                          ? undefined
                          : () => setOpenModalToAuthZoom(true)
                      }
                      disabled={isSubmitting}
                      sx={{
                        cursor: authorizationCode ? 'not-allowed' : 'pointer',
                      }}
                    >
                      <img src={Zoom} alt="Logo do Zoom" />
                      Zoom
                    </ButtonZoom> */}
                    <ButtonZoom
                      isActived={jitsiActived}
                      onClick={() => handleSelectConference('jitsi')}
                    >
                      <img src={Jitsi} alt="Logo do Jitsi" />
                      Jitsi Meet
                    </ButtonZoom>
                    {authorizationCode && (
                      <Tooltip title="Desfazer" placement="top">
                        <Button
                          variant="text"
                          disabled={isSubmitting}
                          color="error"
                          onClick={() => setOpenModalToDisconnectZoom(true)}
                          sx={{ minWidth: '0px', padding: '0' }}
                        >
                          <CloseRounded color="error" />
                        </Button>
                      </Tooltip>
                    )}

                    <ConfirmModal
                      open={openModalToAuthZoom}
                      onClose={() => setOpenModalToAuthZoom(false)}
                      onCancel={() => setOpenModalToAuthZoom(false)}
                      onConfirm={() => handleSelectConference('zoom')}
                      title="Zoom"
                      subtitle="O Zoom abrirá uma janela para conectar em sua conta."
                      text="Lembre-se: se o seu Zoom for gratuito o limite de duração da videochamada é de 40 minutos."
                      btnTextConfirm="PROSSEGUIR"
                      btnTextCancel="CANCELAR"
                      type="success"
                    />
                    <ConfirmModal
                      open={openModalToDisconnectZoom}
                      onClose={() => setOpenModalToDisconnectZoom(false)}
                      onCancel={() => setOpenModalToDisconnectZoom(false)}
                      onConfirm={handleDisconnectZoom}
                      title="Encerrar Conexão com o Zoom"
                      subtitle="Ao confirmar, sua autenticação será revogada e nenhum link do Zoom será gerado."
                      btnTextConfirm="PROSSEGUIR"
                      btnTextCancel="CANCELAR"
                      type="error"
                    />
                  </>
                )}
              </LinkAdress>
              {linkAdress &&
                (isDirty ? (
                  <Tooltip
                    title="Existem alterações que não foram salvas no link da reunião"
                    placement="top-start"
                    arrow
                  >
                    <Box zIndex="1">
                      <Button
                        variant="text"
                        onClick={contentCopy}
                        disabled
                        sx={{
                          textTransform: 'capitalize',
                          fontSize: '14px',
                          fontWeight: '400',
                          color: '#323232',
                          padding: '6px 15px',
                          height: '54px',
                        }}
                        startIcon={<ContentCopyRounded />}
                      >
                        Copiar
                      </Button>
                    </Box>
                  </Tooltip>
                ) : (
                  <Button
                    variant="text"
                    disabled={isSubmitting}
                    onClick={contentCopy}
                    sx={{
                      textTransform: 'capitalize',
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#323232',
                      padding: '6px 15px',
                      height: '54px',
                    }}
                    startIcon={<ContentCopyRounded />}
                  >
                    Copiar
                  </Button>
                ))}
            </Box>

            {jitsiActived && (
              <SuccessOAuth sx={{ alignItems: 'flex-end' }}>
                <CheckCircleOutlineRounded color="success" />
                <TextZoom>
                  O link do Jitsi será gerado ao salvar esta reunião.
                </TextZoom>
              </SuccessOAuth>
            )}

            {authorizationCode && (
              <SuccessOAuth>
                <CheckCircleOutlineRounded color="success" />
                <TextZoom>
                  Autenticação concluída, o link do Zoom será gerado ao salvar
                  esta reunião.
                </TextZoom>
              </SuccessOAuth>
            )}

            {tokenZoom && (
              <>
                {!linkZoomRemoved && (
                  <Button
                    variant="outlined"
                    disabled={isSubmitting}
                    onClick={() => setOpenModalToRemoveZoom(true)}
                    sx={{
                      display: 'flex',
                      height: '48px',
                      padding: '4px 15px',
                      alignItems: 'center',
                      gap: '10px',
                      border: '1px solid #CDCDCD',
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#212b36b3',
                      width: 'fit-content',
                      textTransform: 'capitalize',
                    }}
                  >
                    <CloseRounded sx={{ color: '#212B36' }} /> Remover Zoom
                  </Button>
                )}
                {linkZoomRemoved && (
                  <SuccessRemovedZoom>
                    <CheckCircleOutlineRounded color="success" />
                    <TextRemovedZoom>
                      O link do Zoom será removido no momento em que as edições
                      forem salvas.
                    </TextRemovedZoom>
                  </SuccessRemovedZoom>
                )}
              </>
            )}

            {hasJitsi && (
              <>
                {!linkJitsiRemoved ? (
                  <Button
                    variant="outlined"
                    disabled={isSubmitting}
                    onClick={() => setOpenModalToRemoveJitsi(true)}
                    sx={{
                      display: 'flex',
                      height: '48px',
                      padding: '4px 15px',
                      alignItems: 'center',
                      gap: '10px',
                      border: '1px solid #CDCDCD',
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#212b36b3',
                      width: 'fit-content',
                      textTransform: 'capitalize',
                    }}
                  >
                    <CloseRounded sx={{ color: '#212B36' }} /> Remover Jitsi
                  </Button>
                ) : (
                  <SuccessRemovedZoom>
                    <CheckCircleOutlineRounded color="success" />
                    <TextRemovedZoom>
                      O link do Jitsi será removido no momento em que as edições
                      forem salvas.
                    </TextRemovedZoom>
                  </SuccessRemovedZoom>
                )}
              </>
            )}

            <ConfirmModal
              open={openModalToRemoveJitsi}
              onClose={() => setOpenModalToRemoveJitsi(false)}
              onCancel={() => setOpenModalToRemoveJitsi(false)}
              onConfirm={handleRemoveJitsi}
              title="Desativar Link do Jitsi"
              subtitle="Ao remover o link do Jitsi, a respectiva reunião no Jitsi será permanentemente excluída."
              btnTextConfirm="PROSSEGUIR"
              btnTextCancel="CANCELAR"
              type="warning"
            />
            <ConfirmModal
              open={openModalToRemoveZoom}
              onClose={() => setOpenModalToRemoveZoom(false)}
              onCancel={() => setOpenModalToRemoveZoom(false)}
              onConfirm={handleRemoveZoom}
              title="Desativar Link do Zoom"
              subtitle="Ao remover o link do Zoom, a respectiva reunião no Zoom será permanentemente excluída."
              btnTextConfirm="PROSSEGUIR"
              btnTextCancel="CANCELAR"
              type="warning"
            />
            {/* {showOnlineInputZoom && (
              <Input
                className="inputs"
                type="text"
                label="Link da reunião"
                placeholder="Ex: https://zoom..."
                name="link_address"
                control={control}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )} */}
            {showOnlineInputTeams && (
              <Input
                className="inputs"
                type="text"
                label="Link da reunião"
                placeholder="Ex: https://teams..."
                disabled={isSubmitting}
                name="link_address"
                control={control}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
            {showOnlineInputOthers && (
              <Input
                className="inputs"
                type="text"
                disabled={isSubmitting}
                sx={{ marginTop: '20px' }}
                label="Link da reunião"
                placeholder="Ex: https://link..."
                name="link_address"
                control={control}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </Box>
          <Box display="flex" width="100%" justifyContent="space-between">
            <Button
              variant="outlined"
              color="error"
              onClick={() => setDialogCancelOpen(true)}
              disabled={isSubmitting}
              sx={{
                fontSize: '15px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                height: '42px',
              }}
            >
              Cancelar reunião
            </Button>

            <Button
              variant="contained"
              color="success"
              type="submit"
              disabled={isSubmitting}
              endIcon={isSubmitting && <CircularProgress size={20} />}
              sx={{
                color: '#ffffff',
                fontSize: '15px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                height: '42px',
              }}
            >
              {isSubmitting ? 'Carregando...' : 'Salvar alterações'}
            </Button>
          </Box>
        </form>
      </Section>
    </Container>
  );
}
